import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <path
          d="M 56.956999679565435 64.26599884033203 L 40.542999679565426 43.733998840332035 L 55.91299967956543 25.57999884033203 L 45.76299967956543 25.57999884033203 L 32.07499967956543 42.86399884033203 L 32.07499967956543 25.57999884033203 L 23.83899967956543 25.57999884033203 L 23.83899967956543 64.26599884033203 L 32.07499967956543 64.26599884033203 L 32.07499967956543 52.37599884033203 L 35.09099967956543 48.77999884033203 L 46.806999679565436 64.26599884033203 Z"
          fill="currentColor"
        />
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
